import { Container } from './CardStyles';

interface CardProps {
  children: React.ReactNode;
  sx?: React.CSSProperties;
}

const Card = ({ children, sx }: CardProps) => {
  return (
    <Container
      style={{
        ...sx,
      }}
    >
      {children}
    </Container>
  );
};

export default Card;
